import { TSetRiskManagerDTO } from '@/backend/api/apiKeyAPI'
import { IRiskManagerEnable } from '../../TeamForm.Types'

export const formatRiskSubscriptionPayload = (source: IRiskManagerEnable): TSetRiskManagerDTO => {
  return {
    ...source,
    userHandle: source.userHandle.replace('@', ''),
  }
}
